export const ENGAGEMENT_REMINDER_HELP_TEXT = 'We’ll send an email reminder if the gift is not redeemed.';
